import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { SDUIUPLTWrapper } from "@faire/retailer-visitor-shared/components/SDUI/UPLT/SDUIUPLTWrapper";
import * as React from "react";
export var MaybeSDUIUPLTWrapper = function(props) {
    if (props.shouldTrackUPLT) {
        return /*#__PURE__*/ _jsx(SDUIUPLTWrapper, _object_spread({}, props));
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: props.children
    });
};
